import React, { useContext, useState } from 'react';
import Icons from '../Icons';
import { Context } from "../contexts/AppContext";

function UploadImageBg(props) {
  const [imageFile, setImageFile] = useState(null);
  const { value } = useContext(Context);
  const [appState] = value;
  const [clickType, setClickType]=useState(null)
  console.log('types----- ',props.type)

  const { currentFolderData, currentFolderName, currentGalleryName,currentGalleryData } = appState;

  
  const optimizeImage = (
  file,
  {
    maxWidth = 1280,
    maxHeight = 1280,
    quality = 0.7,
    mimeType = "image/webp",
  } = {}
) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      img.src = reader.result;
    };

    img.onload = () => {
      let { width, height } = img;

      // Maintain aspect ratio
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = width * ratio;
        height = height * ratio;
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject("Image optimization failed");
          const optimizedFile = new File([blob], file.name.replace(/\.\w+$/, ".webp"), {
            type: mimeType,
          });
          resolve(optimizedFile);
        },
        mimeType,
        quality
      );
    };

    img.onerror = reject;
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};


  // Handle file input
const handleFileChange = async (event) => {
  const inputId = event.target.id; // 🟢 e.g. "fileInput-logo"
  const typeFromId = inputId.replace("fileInput-", ""); // 🟡 "logo", "background", etc.

  const file = event.target.files[0];
  if (!file) return;

  // 🔹 Convert file size to MB
  const fileSizeMB = file.size / (1024 * 1024);

  // 🔹 Get available credits in MB (assuming appState.adminDetails.credits is stored in MB)
  const availableCreditsMB = appState?.adminDetails?.credits || 0;

  // 🔹 Condition 1: 40MB size limit check
  if (fileSizeMB > 40) {
    const sizeDisplay =
      fileSizeMB >= 1024
        ? `${(fileSizeMB / 1024).toFixed(2)} GB`
        : `${fileSizeMB.toFixed(2)} MB`;
    alert(`❌ File too large (${sizeDisplay}). Maximum allowed size is 40 MB.`);
    return;
  }

  // 🔹 Condition 2: Available credits check
  if (fileSizeMB > availableCreditsMB) {
    const fileSizeDisplay =
      fileSizeMB >= 1024
        ? `${(fileSizeMB / 1024).toFixed(2)} GB`
        : `${fileSizeMB.toFixed(2)} MB`;

    const creditsDisplay =
      availableCreditsMB >= 1024
        ? `${(availableCreditsMB / 1024).toFixed(2)} GB`
        : `${availableCreditsMB.toFixed(2)} MB`;

    alert(
      `⚠️ Not enough credits!\n\nFile size: ${fileSizeDisplay}\nAvailable credits: ${creditsDisplay}`
    );
    return;
  }

  // ✅ If checks passed, proceed
  props.imgOnPrg();
  // 🔥 OPTIMIZE BEFORE UPLOAD
const optimizedFile = await optimizeImage(file, {
  maxWidth: 1280,
  maxHeight: 1280,
  quality: 0.7,
});
  setImageFile(optimizedFile);
  await handleUpload(optimizedFile, typeFromId);
};


  // Get Presigned URL from Backend
  const getPresignedUrl = async (file) => {
    
 
   // const folderPath = `${currentFolderData.adminId}/${currentFolderData.name}/${currentGalleryName}`;
  
     const folderPath = props.baseUrl?props.baseUrl:`${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}`;
      console.log(folderPath,'appState Upload Image Bg----',appState)
    const presignedApi = `${process.env.REACT_APP_API_PATH}products/generate-presigned-url?folderPath=${folderPath}&fileName=${file.name}&fileType=${file.type}`;
console.log('presigned Api ',presignedApi)
    const response = await fetch(presignedApi, {
      method: "POST",
      headers: { "Content-Type": "image/jpeg" },
      CacheControl: "no-store",
      body: JSON.stringify({
        file_name: `${folderPath}/${file.name}`,
      }),
    });

    return response.json();
  };

  // Upload to S3
  const handleUpload = async (file,typeFromId) => {
    
    try {
      const data = await getPresignedUrl(file);
    
      const { upload_url } = JSON.parse(data.body);
      console.log("DATA ",upload_url)
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", upload_url, true);

      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          const percentComplete = (event.loaded / event.total) * 100;
         props.imgOnPrg()
         
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log("Image uploaded successfully",props.type);
          const timestamp = Date.now();
          const updatedUrl = `${file.name}?t=${timestamp}`;
          props.imgUploadedDone(file, typeFromId);
        } else {
          console.error("Upload failed with status:", xhr.status);
         props.uploadFailed(file)
        }
      };

      xhr.onerror = function () {
        console.log("Network error");
        alert("Network error during upload");
      };

      xhr.send(file);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  // Optional: Delete from S3
  const deleteFileFromS3 = async (fileName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/products/delete-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileName }),
      });

      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div  className=''>
    
      
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
       id={`fileInput-${props.type}`} 
        style={{ display: "none" }}
      />

    <button
  onClick={() => document.getElementById(`fileInput-${props.type}`).click()}
  className="btn-yellow"
>
  {props?.txt ? props.txt : "Upload Image"}
</button>
    </div>
  );
}

export default UploadImageBg;
